/* 31.10 request forms (kindergarten quote, family book, "tell us what you want"): sections/main-gan + main-family.
   Each [data-reqform] block = one form. Submit = one row in the order log (data-plan marks the row in the sheet, in every
   language) + WhatsApp with the same details. The WhatsApp link opens right away and also stays on the thank-you panel,
   in case the browser blocked the new tab. Family rows ([data-member]) become one line per person. */
(() => {
  document.querySelectorAll('[data-reqform]').forEach(S => {
    const form = S.querySelector('form'), done = S.querySelector('[data-done]'), err = S.querySelector('[data-err]'), D = S.dataset;
    if (!form) return;
    const label = el => {
      const fs = el.type === 'radio' && el.closest('fieldset'), l = fs ? fs.querySelector('legend') : S.querySelector(`label[for="${el.id}"]`);
      return (l ? l.textContent : el.getAttribute('aria-label') || '').trim();
    };
    const fields = () => {
      const seen = new Set(), out = [];
      form.querySelectorAll('[data-k]').forEach(el => {
        if (seen.has(el.dataset.k) || el.closest('[data-member]')) return;
        const v = el.type === 'radio' ? (form.querySelector(`[data-k="${el.dataset.k}"]:checked`) || {}).value || '' : el.value.trim();
        seen.add(el.dataset.k); out.push({ k: el.dataset.k, el, label: label(el), v });
      });
      return out;
    };
    const members = () => [...form.querySelectorAll('[data-member]:not([hidden])')].map(row => {
      const g = k => (row.querySelector(`[data-m="${k}"]`) || {}).value || '';
      return g('name').trim() ? `${g('name').trim()}${g('age').trim() ? ', ' + g('age').trim() : ''}${g('role') ? ' - ' + g('role') : ''}` : '';
    }).filter(Boolean);
    const add = form.querySelector('[data-add-member]');
    if (add) add.addEventListener('click', () => {
      const next = form.querySelector('[data-member][hidden]'); if (next) { next.hidden = false; next.querySelector('input').focus(); }
      if (!form.querySelector('[data-member][hidden]')) add.hidden = true;
    });
    form.addEventListener('input', e => { e.target.removeAttribute('aria-invalid'); if (err) err.textContent = ''; });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const f = fields(), m = members();
      for (const x of f) {
        const bad = x.el.required && !x.v ? D.req : x.k === 'phone' && x.v.replace(/\D/g, '').length < 9 ? D.tel : '';
        if (bad) { err.textContent = `${x.label}: ${bad}`; x.el.setAttribute('aria-invalid', 'true'); x.el.focus(); return; }
      }
      if (form.querySelector('[data-member]') && !m.length) {
        const first = form.querySelector('[data-member] [data-m="name"]');
        err.textContent = D.memb; first.setAttribute('aria-invalid', 'true'); first.focus(); return;
      }
      const get = k => (f.find(x => x.k === k) || {}).v || '';
      const lines = [D.intro, ''].concat(m.length ? [D.membLabel + ':'].concat(m.map(x => '- ' + x), ['']) : [],
                                         f.filter(x => x.v).map(x => `${x.label}: ${x.v}`));
      const btn = form.querySelector('[type=submit]'); btn.disabled = true;
      // 3.11 Yonatan (test first): a page that opts in with data-lead (the organisations page) tells Meta about the lead - here,
      // inside the submit handler after validation, never on page load. track.js turns it into fbq('track', 'Lead').
      if (D.lead) {
        document.dispatchEvent(new CustomEvent('historia:lead', { detail: { content_name: D.plan } }));
        // the live measurement runs through Shopify's pixels (Customer events), not track.js (no fb_pixel id is set):
        // publish the lead there too, for a custom pixel to forward to Meta as 'Lead'
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('historia_lead', { content_name: D.plan }); } catch (e3) {}
      }
      if (D.log) {
        const b = new URLSearchParams({ lang: document.documentElement.lang || 'he', name: [get('contact'), get('gan')].filter(Boolean).join(' · '),
          phone: get('phone'), plan: D.plan, price: '', extra: '', details: lines.join('\n'), photos: '' });
        try { await fetch(D.log, { method: 'POST', mode: 'no-cors', keepalive: true, body: b }); } catch (e2) {}
      }
      const url = 'https://wa.me/' + D.phone + '?text=' + encodeURIComponent(lines.join('\n'));
      done.querySelector('a').href = url;
      form.hidden = true; done.hidden = false; btn.disabled = false;
      done.focus(); done.scrollIntoView({ block: 'center' });
      window.open(url, '_blank', 'noopener');
    });
  });
})();
